import React, { useContext } from 'react';
import FeatureSlider from '@React_UI_Lib/FeatureSlider';
import { CabsLandingContext } from '../../../../CabsLandingContext';
import { getCabLandingShortCodeFromTripType } from '../../../../constants/tripTypes';
import './WhatsNew.css';

export type CardInfotype = {
  profile_type: string;
  data: CardType[];
  title_icon_link: string;
  type: string;
  title: string;
};

export type CardType = {
  image: string;
  bg_color: string;
  omniture_key: string;
  trip_types: string[];
  heading: string;
  sub_heading: string;
  link: string;
  link_text: string;
};

export const WhatsNew = ({
  whatsNewInfo = null
}: {
  whatsNewInfo: CardInfotype | null;
}) => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const { travelFor } = cabsLandingContext;

  const getRelevantCards = () => {
    if (whatsNewInfo?.data && whatsNewInfo?.data?.length > 0) {
      return whatsNewInfo?.data?.filter((whatsNewCard: CardType) => {
        return whatsNewCard.trip_types.includes(
          getCabLandingShortCodeFromTripType(travelFor)
        );
      });
    }
    return [];
  };

  const relevantWhatsNewCard = getRelevantCards();
  const showWhatsNewSection = relevantWhatsNewCard.length > 0;

  const title = whatsNewInfo?.title;
  const featureArr = relevantWhatsNewCard.map(
    ({ image, bg_color, heading, sub_heading, link, link_text }) => ({
      featureImgUrl: image,
      label: heading,
      href: link,
      info: sub_heading,
      borderColor: '#FFEDD1',
      BtnText: link_text,
      imgContainerStyle: {
        backgroundColor: bg_color,
        border: '1px solid rgb(214, 235, 255)'
      },
      imgStyle: {
        width: '29px',
        height: '29px'
      }
    })
  );

  return showWhatsNewSection ? (
    <div className="whatsNew" id="whatsnewSection">
      <div style={{ backgroundColor: '#ffffff' }}>
        <FeatureSlider featureArr={featureArr} sectionTitle={title} />
      </div>
    </div>
  ) : (
    <div className="whatsNew" id="whatsnewSection"></div>
  );
};
